exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-ir-35-calculator-tsx": () => import("./../../../src/pages/ir35Calculator.tsx" /* webpackChunkName: "component---src-pages-ir-35-calculator-tsx" */),
  "component---src-pages-national-insurance-optimiser-tsx": () => import("./../../../src/pages/nationalInsuranceOptimiser.tsx" /* webpackChunkName: "component---src-pages-national-insurance-optimiser-tsx" */)
}

